import Base from './Base';
import Brightness from './Brightness';
import Color from './Color';
import ColorTemperatureInKelvin from './ColorTemperatureInKelvin';
import Connectivity from './Connectivity';
import DetectionState from './DetectionState';
import LockState from './LockState';
import Mode from './Mode';
import Muted from './Muted';
import Percentage from './Percentage';
import PowerState from './PowerState';
import RelativeHumidity from './RelativeHumidity';
import RangeValue from './RangeValue';
import TargetSetpoint from './TargetSetpoint';
import Temperature from './Temperature';
import ThermostatMode from './ThermostatMode';
import Volume from './Volume';

export default {
    Base,
    Brightness,
    Color,
    ColorTemperatureInKelvin,
    Connectivity,
    DetectionState,
    LockState,
    Mode,
    Muted,
    Percentage,
    PowerState,
    RangeValue,
    RelativeHumidity,
    TargetSetpoint,
    Temperature,
    ThermostatMode,
    Volume,
};
